import { FC } from "react";

type IProps = {
  stroke?: string;
  style?: React.CSSProperties;
  className?: string;
};

const TrashIcon2: FC<IProps> = ({ stroke = "#D83535", style, className }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M20.75 5.75H4.25"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 10.25V16.25"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.75 10.25V16.25"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.25 5.75V20C19.25 20.1989 19.171 20.3897 19.0303 20.5303C18.8897 20.671 18.6989 20.75 18.5 20.75H6.5C6.30109 20.75 6.11032 20.671 5.96967 20.5303C5.82902 20.3897 5.75 20.1989 5.75 20V5.75"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 5.75V4.25C16.25 3.85218 16.092 3.47064 15.8107 3.18934C15.5294 2.90804 15.1478 2.75 14.75 2.75H10.25C9.85218 2.75 9.47064 2.90804 9.18934 3.18934C8.90804 3.47064 8.75 3.85218 8.75 4.25V5.75"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TrashIcon2;
